<template>
    <div class="searchContent">
        <a-card :title="this.$slots.default">

            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="所属领域">
                    <a-select style="width:100px" placeholder="请选择服务所属领域" v-decorator="[
                                'domain',
                                {
                                    initialValue: record.domain ? record.domain : [''],
                                    rules: [{ required: false, message: '所属领域' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="001">前台</a-select-option>
                        <a-select-option key="002">中台</a-select-option>
                        <a-select-option key="003">开放</a-select-option>
                        <a-select-option key="004">基础</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="应用编码">
                    <AppAutoComplete ref="appcodeAss" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>
                <a-form-item label="关键字">
                    <a-input v-decorator="[
                                'keyword',
                                {
                                    initialValue: record.keyword || '',
                                }
                            ]" placeholder="服务KEY或服务配置或描述"></a-input>
                </a-form-item>
                

                <a-form-item label="目标分支">
                            
                    <BranchAutoComplete ref="branchAss" @onBranchChange="handleBranchChange"></BranchAutoComplete>
                    
                </a-form-item>

                

                <a-form-item label="关联服务">
                    <a-input v-decorator="[
                                'routeservicekey',
                                {
                                    initialValue: record.routeservicekey || '',
                                }
                            ]" placeholder="关联服务关键字"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key"
                        :loading="this.loading.effects[selectType] || this.loading.effects[`${storeNamespace}/jibie`]">
                        查询
                    </a-button>
                    <v-resetbutton v-if="action != 'compare'" :key="Math.random()"
                        :loading="this.loading.effects[selectType] || this.loading.effects[`${storeNamespace}/jibie`]"
                        :redirect="{path:`/${storeNamespace}/${action}`}" class="ml15">重置
                    </v-resetbutton>
                    <a-button type="default" @click="goBack" style="margin-left:18px;">
                        返回
                    </a-button>
                    <a-button type="link" style="margin-left:10px;" @click="() => {showMore = !showMore}">{{ showMore ? '收起' : '更多' }}</a-button> 

                    
                </a-form-item>
                
                
                <div v-show="showMore">
                <a-form-item label="负责人">
                    <a-input v-decorator="[
                                'serviceadmin',
                                {
                                    initialValue: record.serviceadmin || '',
                                }
                            ]" placeholder="负责人姓名"></a-input>
                </a-form-item>
                
                <a-form-item label="接口类型">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'interfacetype',
                                {
                                    initialValue: record.interfacetype ? record.interfacetype : [''],
                                    rules: [{ required: false, message: '接口类型' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="http">http</a-select-option>
                        <a-select-option key="rpc">rpc</a-select-option>
                        <a-select-option key="dispatch">dispatch</a-select-option>
                        <a-select-option key="local">local</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="免鉴权">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'entry',
                                {
                                    initialValue: record.entry ? record.entry : [''],
                                    rules: [{ required: false, message: '免鉴权' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="1">是</a-select-option>
                        <a-select-option key="0">否</a-select-option>

                    </a-select>
                </a-form-item>

                <a-form-item label="参数转换">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'parameter',
                                {
                                    initialValue: record.parameter ? record.parameter : [''],
                                    rules: [{ required: false, message: '参数转换' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="1">是</a-select-option>
                        <a-select-option key="0">否</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="路由其它领域">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'routeflag',
                                {
                                    initialValue: record.routeflag ? record.routeflag : [''],
                                    rules: [{ required: false, message: '路由其它领域' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="1">是</a-select-option>
                        <a-select-option key="0">否</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="上下线">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'serviceflag',
                                {
                                    initialValue: record.serviceflag ? record.serviceflag : [''],
                                    rules: [{ required: false, message: '上下线' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="1">上线</a-select-option>
                        <a-select-option key="0">下线</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="是否验签">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'encryptflag',
                                {
                                    initialValue: record.encryptflag ? record.encryptflag : [''],
                                    rules: [{ required: false, message: '是否验签' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="0">否</a-select-option>
                        <a-select-option key="1">是</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item label="收费">
                    <a-select style="width:100px" placeholder="请选择" v-decorator="[
                                'ischarge',
                                {
                                    initialValue: record.ischarge ? record.ischarge : [''],
                                    rules: [{ required: false, message: '收费' }]
                                }
                            ]">
                        <a-select-option key="">全部</a-select-option>
                        <a-select-option key="1">是</a-select-option>
                        <a-select-option key="0">否</a-select-option>

                    </a-select>
                </a-form-item>


                <a-form-item label="开始日期">
                    <a-date-picker width="100px" v-decorator="[
                                'starttime',
                                {
                                    initialValue: record.starttime || '',
                                }
                            ]" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" />
                </a-form-item>
                <a-form-item label="结束日期">
                    <a-date-picker v-decorator="[
                                'endtime',
                                {
                                    initialValue: record.endtime || '',
                                }
                            ]" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" />
                </a-form-item>

                </div>

                
                
                
            </a-form>
        </a-card>
    </div>
</template>

<script>
import AppAutoComplete from '@/components/AppAutoComplete'
import BranchAutoComplete from '@/components/BranchAutoComplete'

const storeNamespace = "servicekey";

export default {

    data() {
        return {
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/delete`,
            form: this.$form.createForm(this),
            record: this.$route.query || {},
            action: "",
            searchAppcode: '',
            searchBranchcode:'',
            showMore:false,
            iscompare:false,
        };
    },
    computed: {},
    methods: {
        goBack() {
            this.$router.back(-1);
        },
        handleSearchAppcodeChange(value) {
            this.searchAppcode = value;
        },
        handleBranchChange(value){
            this.searchBranchcode = value
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                /**
                 * 是的你没看错，这边触发重新去查询数据，只要让路由改变query的参数值即可，无需this.$store.dispatch({})去调用actions里面的方法，
                 * dispatch由同辈级(兄弟组件)  tablelist.vue 中去处理。
                 */
                values.appcode = this.searchAppcode;
                values.targetbranch = this.searchBranchcode;
                values.endtime = values.endtime ? this.dateFormat('YYYY-mm-dd HH:MM', new Date(values.endtime)) : '';
                values.starttime = values.starttime ? this.dateFormat('YYYY-mm-dd HH:MM', new Date(values.starttime)) : '';

                if(this.action == 'compare'){
                    this.$emit('onSearchChange',values)
                }
                else{
                    this.$router.push({
                        path: this.action,
                        query: values
                    });
                }
                
            });
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },
    },
    beforeMount() {
    },
    components: {
        AppAutoComplete,
        BranchAutoComplete
    },
    mounted() {
        const {query, path} = this.$route;
        this.action = path.split("/").pop();
        this.searchAppcode = query.appcode ? query.appcode : '';
        this.searchBranchcode = query.targetbranch ? query.targetbranch : '';
        this.$refs.appcodeAss.setInputVal(this.searchAppcode);
        this.$refs.branchAss.setInputVal(this.searchBranchcode);

        let target = this.record;
        if(target.serviceadmin || target.interfacetype || target.entry || target.routeflag || target.ischarge || target.starttime || target.endtime || target.parameter){
            this.showMore = true;
        }
        if(this.action == 'compare'){
            this.$emit('onSearchChange',target)
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-bottom: 20px;
}
</style>
